import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { urlList } from '../urlConstants';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from './auth.service';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class BaseService {
  private baseUrl = localStorage.getItem('api_url');
  public httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };

  constructor(
    private http: HttpClient,
    private toaster: ToastrService,
    private auth: AuthService,
    private router: Router,
  ) { }

  private createHeaders(): HttpHeaders {
    let token = JSON.parse(localStorage.getItem('token'));
    return new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token.access_token,
    });
  }

  private refreshToken(callback: () => Observable<any>): Observable<any> {
    if (this.auth.isTokenValid()) {
      return callback();
    } else {
      return this.auth.refreshToken().pipe(
        switchMap(() => callback()),
        catchError((err) => {
          this.router.navigate(['/login']);
          return throwError(() => err);
        })
      );
    }
  }

  post(url, data): Observable<any> {
    return this.refreshToken(() => this.http
      .post<any>(this.baseUrl + url, data, { headers: this.createHeaders() })
      .pipe(catchError(this.errorHandler)));
  };

  postHttp(url, data): Observable<any> {
    return this.refreshToken(() => this.http
      .post<any>(url, data, { headers: this.createHeaders() })
      .pipe(catchError(this.errorHandler)));
  }

  postWithCsv(url, data) {
    return this.refreshToken(() =>
      this.http.post(this.baseUrl + url, data, {
        headers: this.createHeaders(),
        responseType: 'blob',
      }).pipe(catchError(this.errorHandler))
    );
  }

  get(url): Observable<any> {
    this.baseUrl = environment.api_url;
    return this.refreshToken(() => this.http.get<any>(url, { headers: this.createHeaders() })
      .pipe(catchError(this.errorHandler)));
  }

  getWithToken(url): Observable<any> {
    this.baseUrl = localStorage.getItem('api_url');
    return this.refreshToken(() => this.http
      .get<any>(this.baseUrl + url, { headers: this.createHeaders() })
      .pipe(catchError(this.errorHandler)));
  }

  getAdmin(url): Observable<any> {
    return this.refreshToken(() => this.http
      .get<any>(this.baseUrl + url, { headers: this.createHeaders() })
      .pipe(catchError(this.errorHandler)));
  }

  patch(url, data): Observable<any> {
    return this.refreshToken(() => this.http
      .patch<any>(this.baseUrl + url, JSON.stringify(data), { headers: this.createHeaders() })
      .pipe(catchError(this.errorHandler)));
  }

  put(url, data): Observable<any> {
    return this.refreshToken(() => this.http
      .put<any>(this.baseUrl + url, JSON.stringify(data), { headers: this.createHeaders() })
      .pipe(catchError(this.errorHandler)));
  }

  putWithoutData(url): Observable<any> {
    return this.refreshToken(() => this.http
      .put<any>(this.baseUrl + url, {}, { headers: this.createHeaders() })
      .pipe(catchError(this.errorHandler)));
  }

  delete(url, data?): Observable<any> {
    const header: HttpHeaders = new HttpHeaders().append(
      'Content-Type',
      'application/json; charset=UTF-8'
    );
    const httpOptions = {
      headers: header,
      body: data,
    };

    return this.http
      .delete<any>(this.baseUrl + url, httpOptions)
      .pipe(catchError(this.errorHandler));
  }
  errorHandler = (error) => {
    console.log(error, "error")
    let errorMessage = '';
    if (error.status === 401 && error.url.indexof('/login') < 0) {
      this.auth.refreshToken();
    } else {
      if (typeof error === 'string') {
        errorMessage = error ? error : 'server error';
      } else {
        errorMessage = `${error.error.message}`;
      }
    }
    return throwError(errorMessage);
  }
}
